import { Box, Fade } from '@mui/material';
import * as React from 'react';
import { Question } from '../../types/questionnaire.types';
import { EssayQuestion } from '../QuestionTypes/EssayQuestion';
import { MatrixScaleQuestion } from '../QuestionTypes/MatrixScaleQuestion';
import { MultipleChoiceCheckboxQuestion } from '../QuestionTypes/MultipleChoiceCheckboxQuestion';
import { MultipleChoiceQuestion } from '../QuestionTypes/MultipleChoiceQuestion';
import { RankingQuestion } from '../QuestionTypes/RankingQuestion';
import { TrueFalseQuestion } from '../QuestionTypes/TrueFalseQuestion';
import { QuestionHeader } from '../shared/QuestionHeader';

interface QuestionCardProps {
  question: Question;
  questionNumber: number;
  response: string;
  isAnswered: boolean;
  onResponseChange: (questionId: string, value: string) => void;
  onCheckboxChange: (
    questionId: string,
    answerId: string,
    checked: boolean
  ) => void;
  onMatrixChange: (questionId: string, rowId: string, answerId: string) => void;
  onEssayChange: (questionId: string, text: string, question: Question) => void;
  onRankingChange: (questionId: string, value: string) => void;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({
  question,
  questionNumber,
  response,
  isAnswered,
  onResponseChange,
  onCheckboxChange,
  onMatrixChange,
  onEssayChange,
  onRankingChange,
}) => {
  return (
    <Fade in timeout={600}>
      <Box
        sx={{
          mb: 3,
          p: '0 !important',
          borderRadius: '16px !important',
        }}
      >
        <Box sx={{ p: '0 !important' }}>
          <QuestionHeader
            questionNumber={questionNumber}
            questionText={question.question}
            isRequired={question.required || false}
            isAnswered={isAnswered}
          />

          {question.type === 'multiple_choice' && (
            <MultipleChoiceQuestion
              question={question}
              response={response}
              onResponseChange={onResponseChange}
            />
          )}

          {question.type === 'multiple_choice_checkbox' && (
            <MultipleChoiceCheckboxQuestion
              question={question}
              response={response}
              onCheckboxChange={onCheckboxChange}
            />
          )}

          {question.type === 'true_false' && (
            <TrueFalseQuestion
              question={question}
              response={response}
              onResponseChange={onResponseChange}
            />
          )}

          {question.type === 'matrix_scale' && (
            <MatrixScaleQuestion
              question={question}
              response={response}
              onMatrixChange={onMatrixChange}
            />
          )}

          {question.type === 'essay' && (
            <EssayQuestion
              question={question}
              response={response}
              onEssayChange={onEssayChange}
            />
          )}

          {question.type === 'ranking' && (
            <RankingQuestion
              question={question}
              response={response}
              onRankingChange={onRankingChange}
            />
          )}
        </Box>
      </Box>
    </Fade>
  );
};
